import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { PrivateRoutes } from "./private";
import { PublicRoutes } from "./public";

export function Routes() {
  const { isAuthenticated, loading } = useBoundStore(
    useShallow((state) => ({
      isAuthenticated: state.user.isAuthenticated,
      loading: state.user.loading,
    }))
  );

  if (loading) return null;

  return isAuthenticated ? <PrivateRoutes /> : <PublicRoutes />;
}
